// extracted by mini-css-extract-plugin
module.exports = {"copy_text":"CopyText_copy_text__d1yKU","vpn_key":"CopyText_vpn_key__RBdNR"};